<div
    class="badge"
    fxLayout="row"
    fxLayoutAlign="start center"
    [class.header]="headerStyle"
    [class.available]="connector | isAvailable"
    [class.faulted]="connector | isFaulted"
    [class.charging]="connector | isCharging"
    [class.preparing]="connector | isPreparing"
    [class.finishing]="connector | isFinishing"
    [class.self-test]="connector | isSelfTest"
    [dialogLink]="
        headerStyle
            ? undefined
            : [
                  'connector',
                  connector?.stationId || globalSearchConnector?.stationId || globalSearchConnector?.station?.stationId,
                  connector?.evseId || globalSearchConnector?.evseId,
              ]
    "
>
    <!-- connector icon -->
    <mat-icon svgIcon="k-connector"></mat-icon>

    <!-- connector location -->
    <div fxFlex class="info" fxLayout="column">
        <span class="content" [attr.title]="location | ceCustomerPrivacy: 'location'"> Connector </span>
        <span i18n="Connector badge|Badge header">{{ location | ceCustomerPrivacy: 'location' }} </span>
    </div>

    <!-- connector id -->
    <ce-connector-pill [connector]="connector" [globalSearchConnector]="globalSearchConnector"></ce-connector-pill>
</div>
